<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    dark
    class="d-print-none app"
  >
    <v-app-bar-nav-icon @click.stop="toggleDrawer" />
    <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
      <span class="hidden-sm-and-down">eduplusschool</span>
    </v-toolbar-title>

    <v-spacer />

    <div class="text-right mb-2 mt-2">
      <v-avatar
        v-if="!firefoxAgent"
        class="ma-2 white--text"
        size="50"
        outlined
      >
        <Speed />
      </v-avatar>
    </div>
    <!-- <v-btn icon>
  
    </v-btn> -->
    <div style="width: 10px"></div>
    <div class="text-center">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
        transition="scroll-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <span v-if="profile_image_path">
              <v-avatar>
                <v-img
                  :src="awspath + profile_image_path + profile_image_name"
                ></v-img>
              </v-avatar>
            </span>
            <span v-else>
              <v-avatar color="white">
                <span class="text headline">{{ initials }}</span>
              </v-avatar>
            </span>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Hello, {{ uid }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <span
              @click="closeMenuAndLogout()"
              style="cursor: pointer; color: #b71c1c"
              ><b> Sign Out </b></span
            >
            <v-btn
              class="ma-1"
              outlined
              small
              fab
              color="error"
              @click="closeMenuAndLogout()"
              title="logout"
            >
              <v-icon>mdi-location-exit</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>
<script>
import Speed from "../shared/Speed";

export default {
  components: {
    Speed,
  },
  data: () => ({
    initials: "",
    menu: false,
    username: "",
    uid: "",
    data: {},
    profile_image_name: "",
    profile_image_path: "",
    profile: null,
    firefoxAgent: false,
    home_url: null,
  }),

  methods: {
    toggleDrawer() {
      this.$store.state.drawer = !this.$store.state.drawer;
    },
    closeMenuAndLogout() {
      this.menu = false;
      localStorage.clear();
      this.$router.push("/management-login");
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.uid = localStorage.getItem("EPS-uid");
   // this.home_url = this.$route.fullPath; //will get currentPath
  },
};
</script>
<style scoped>
.sidebar-link {
  text-decoration: none;
}
.sidebar-link-item:hover {
  background-color: rgb(181, 186, 190) !important;
}
.app1 {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.app {
  background: linear-gradient(
    to right,
    rgb(41, 128, 185),
    rgb(109, 213, 250),
    rgb(41, 128, 185)
  ); /*#0F2027;  /* fallback for old browsers */
  /* background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right, #2C5364, #203A43, #0F2027); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.text {
  color: #0f2027;
}
</style>